module.exports = __webpack_public_path__ + "static/media/IMG_4632 vanity close up.94cf1e6b.JPG";